const SESSION_TIME_LIMIT_HOURS = 24; // 24 hours?, 0.01 for testing
export const WARNING_DURATION_SECONDS = 60; // 60 seconds, 10 for testing

let sessionTimeoutId = null;
let warningIntervalId = null;
let warningTimeoutId = null;
let isWarningOpen = false;

let callbacks = {
  showWarning: null,
  updateWarningCountdown: null,
  hideWarning: null,
  logoutUser: null,
  continueSessionWithBackend: null
};

function getStoredNumber(key) {
  const value = Number(localStorage.getItem(key));
  return Number.isFinite(value) ? value : null;
}

export function startSession() {
  console.log('startSession called')

  const now = Date.now();
  const sessionExpiresAt = now + SESSION_TIME_LIMIT_HOURS * 60 * 60 * 1000;

  // localStorage.setItem("lastAuthCheck", String(now));
  localStorage.setItem("sessionExpiresAt", String(sessionExpiresAt));

  // Important: starting/continuing a session should clear any old warning deadline
  localStorage.removeItem("warningExpiresAt");

  scheduleSessionCheck();
}

export function initializeSessionManager(options) {
  callbacks = {
    ...callbacks,
    ...options
  };

  if (!isUserLoggedIn()) return;

  checkSessionExpiration();
  scheduleSessionCheck();

  window.addEventListener("focus", handleWindowFocus);
  document.addEventListener("visibilitychange", handleVisibilityChange);
}

export function destroySessionManager() {
  clearTimeout(sessionTimeoutId);
  clearInterval(warningIntervalId);
  clearTimeout(warningTimeoutId);

  window.removeEventListener("focus", handleWindowFocus);
  document.removeEventListener("visibilitychange", handleVisibilityChange);
}

function isUserLoggedIn() {
  const email = localStorage.getItem("email");
  const username = localStorage.getItem("username");
  const sessionExpiresAt = localStorage.getItem("sessionExpiresAt");

  return !!(email || username) && !!sessionExpiresAt;
}

function handleWindowFocus() {
  checkSessionExpiration();
}

function handleVisibilityChange() {
  if (document.visibilityState === "visible") {
    checkSessionExpiration();
  }
}

function scheduleSessionCheck() {
  clearTimeout(sessionTimeoutId);

  const sessionExpiresAt = Number(localStorage.getItem("sessionExpiresAt"));

  if (!sessionExpiresAt) return;

  const msUntilExpiration = sessionExpiresAt - Date.now();

  if (msUntilExpiration <= 0) {
    checkSessionExpiration();
    return;
  }

  sessionTimeoutId = setTimeout(() => {
    checkSessionExpiration();
  }, msUntilExpiration);
}

// export function checkSessionExpiration() {
//   if (!isUserLoggedIn()) return;
//
//   const sessionExpiresAt = Number(localStorage.getItem("sessionExpiresAt"));
//
//   if (!sessionExpiresAt) return;
//
//   if (Date.now() >= sessionExpiresAt) {
//     promptLogoutWarning();
//   } else {
//     scheduleSessionCheck();
//   }
// }

export function checkSessionExpiration() {
  if (!isUserLoggedIn()) return;

  const sessionExpiresAt = getStoredNumber("sessionExpiresAt");

  if (!sessionExpiresAt) return;

  if (Date.now() >= sessionExpiresAt) {
    handleExpiredSession();
  } else {
    scheduleSessionCheck();
  }
}

// function handleExpiredSession() {
//   let warningExpiresAt = getStoredNumber("warningExpiresAt");
//
//   // If this is the first time the expired session is detected,
//   // create a persistent 60-second warning deadline.
//   if (!warningExpiresAt) {
//     warningExpiresAt = Date.now() + WARNING_DURATION_SECONDS * 1000;
//     localStorage.setItem("warningExpiresAt", String(warningExpiresAt));
//   }
//
//   const secondsRemaining = Math.ceil((warningExpiresAt - Date.now()) / 1000);
//
//   // If the warning period already expired, log out immediately.
//   // This handles reloads after the countdown should have ended.
//   if (secondsRemaining <= 0) {
//     clearInterval(warningIntervalId);
//     isWarningOpen = false;
//
//     if (callbacks.logoutUser) {
//       callbacks.logoutUser("session_expired");
//     }
//
//     return;
//   }
//
//   promptLogoutWarning(secondsRemaining);
// }

function handleExpiredSession() {
  let warningExpiresAt = getStoredNumber("warningExpiresAt");

  if (!warningExpiresAt) {
    warningExpiresAt = Date.now() + WARNING_DURATION_SECONDS * 1000;
    localStorage.setItem("warningExpiresAt", String(warningExpiresAt));
  }

  const secondsRemaining = Math.ceil((warningExpiresAt - Date.now()) / 1000);

  if (secondsRemaining <= 0) {
    forceLogout("session_expired");
    return;
  }

  promptLogoutWarning(secondsRemaining);
}

// function promptLogoutWarning() {
//   if (isWarningOpen) return;
//
//   isWarningOpen = true;
//
//   let secondsRemaining = WARNING_DURATION_SECONDS;
//
//   if (callbacks.showWarning) {
//     callbacks.showWarning(secondsRemaining);
//   }
//
//   warningIntervalId = setInterval(() => {
//     secondsRemaining -= 1;
//
//     if (callbacks.updateWarningCountdown) {
//       callbacks.updateWarningCountdown(secondsRemaining);
//     }
//
//     if (secondsRemaining <= 0) {
//       clearInterval(warningIntervalId);
//       isWarningOpen = false;
//
//       if (callbacks.logoutUser) {
//         callbacks.logoutUser("session_expired");
//       }
//     }
//   }, 1000);
// }

// function promptLogoutWarning(startingSecondsRemaining) {
//   if (isWarningOpen) return;
//
//   isWarningOpen = true;
//
//   if (callbacks.showWarning) {
//     callbacks.showWarning(startingSecondsRemaining);
//   }
//
//   clearInterval(warningIntervalId);
//
//   warningIntervalId = setInterval(() => {
//     const warningExpiresAt = getStoredNumber("warningExpiresAt");
//
//     if (!warningExpiresAt) {
//       clearInterval(warningIntervalId);
//       isWarningOpen = false;
//       return;
//     }
//
//     const secondsRemaining = Math.ceil((warningExpiresAt - Date.now()) / 1000);
//     const safeSecondsRemaining = Math.max(secondsRemaining, 0);
//
//     if (callbacks.updateWarningCountdown) {
//       callbacks.updateWarningCountdown(safeSecondsRemaining);
//     }
//
//     if (secondsRemaining <= 0) {
//       clearInterval(warningIntervalId);
//       isWarningOpen = false;
//
//       if (callbacks.logoutUser) {
//         callbacks.logoutUser("session_expired");
//       }
//     }
//   }, 1000);
// }

function promptLogoutWarning(startingSecondsRemaining) {
  // Always clear and restart these when entering warning mode.
  // This prevents reload/remount/focus weirdness from leaving a stale interval.
  clearInterval(warningIntervalId);
  clearTimeout(warningTimeoutId);

  isWarningOpen = true;

  if (callbacks.showWarning) {
    callbacks.showWarning(startingSecondsRemaining);
  }

  const warningExpiresAt = getStoredNumber("warningExpiresAt");

  if (!warningExpiresAt) {
    forceLogout("session_expired");
    return;
  }

  const msUntilWarningExpires = warningExpiresAt - Date.now();

  if (msUntilWarningExpires <= 0) {
    forceLogout("session_expired");
    return;
  }

  // Hard backup: log out when the warning deadline passes,
  // even if the visible countdown interval fails.
  warningTimeoutId = setTimeout(() => {
    forceLogout("session_expired");
  }, msUntilWarningExpires);

  // Visual countdown: update the modal every second from the stored deadline.
  warningIntervalId = setInterval(() => {
    const currentWarningExpiresAt = getStoredNumber("warningExpiresAt");

    if (!currentWarningExpiresAt) {
      clearInterval(warningIntervalId);
      clearTimeout(warningTimeoutId);
      isWarningOpen = false;
      return;
    }

    const secondsRemaining = Math.ceil(
      (currentWarningExpiresAt - Date.now()) / 1000
    );

    const safeSecondsRemaining = Math.max(secondsRemaining, 0);

    if (callbacks.updateWarningCountdown) {
      callbacks.updateWarningCountdown(safeSecondsRemaining);
    }

    if (secondsRemaining <= 0) {
      forceLogout("session_expired");
    }
  }, 1000);
}

function forceLogout(reason) {
  clearTimeout(sessionTimeoutId);
  clearInterval(warningIntervalId);
  clearTimeout(warningTimeoutId);

  isWarningOpen = false;

  localStorage.removeItem("warningExpiresAt");

  if (callbacks.logoutUser) {
    callbacks.logoutUser(reason);
  }
}

// export async function continueSession() {
//   clearInterval(warningIntervalId);
//
//   try {
//     if (callbacks.continueSessionWithBackend) {
//       const result = await callbacks.continueSessionWithBackend();
//       console.log('log the result', result)
//       if (!result || !result.success) {
//         isWarningOpen = false;
//
//         if (callbacks.logoutUser) {
//           callbacks.logoutUser(result?.errorCode || "session_invalid");
//         }
//
//         return;
//       }
//     }
//
//     startSession();
//
//     isWarningOpen = false;
//
//     if (callbacks.hideWarning) {
//       callbacks.hideWarning();
//     }
//   } catch (error) {
//     isWarningOpen = false;
//
//     if (callbacks.logoutUser) {
//       callbacks.logoutUser("session_error");
//     }
//   }
// }

export async function continueSession() {
  clearInterval(warningIntervalId);
  clearTimeout(warningTimeoutId);

  try {
    if (callbacks.continueSessionWithBackend) {
      const result = await callbacks.continueSessionWithBackend();

      console.log('log the result', result);

      if (!result || !result.success) {
        isWarningOpen = false;
        localStorage.removeItem("warningExpiresAt");

        if (callbacks.logoutUser) {
          callbacks.logoutUser(result?.errorCode || "session_invalid");
        }

        return;
      }
    }

    localStorage.removeItem("warningExpiresAt");

    startSession();

    isWarningOpen = false;

    if (callbacks.hideWarning) {
      callbacks.hideWarning();
    }
  } catch (error) {
    isWarningOpen = false;
    localStorage.removeItem("warningExpiresAt");

    if (callbacks.logoutUser) {
      callbacks.logoutUser("session_error");
    }
  }
}

// export function cancelSessionAndLogout() {
//   clearInterval(warningIntervalId);
//   isWarningOpen = false;
//
//   if (callbacks.logoutUser) {
//     callbacks.logoutUser("manual_logout");
//   }
// }

export function cancelSessionAndLogout() {
  forceLogout("manual_logout");
}
